























import { Component, Vue } from "vue-property-decorator";
import { newGameList } from "@/req/homes";
import boxCom from "./newGoOnlineCom/boxCom.vue";
@Component({
  components: { boxCom },
})
export default class Home extends Vue {
  public gameList: any = [];
  public mounted() {
    this.getList();
  }
  public async getList() {
    const res = await newGameList();
    if (res.code == 200) {
      try {
        const arr: any = [];
        for (const i of Object.keys(res.data)) {
          arr.push({
            id: this.compareDate(i),
            date: i,
            list: res.data[i],
          });
        }
        this.gameList = arr;
      } catch (error) {
        if (error instanceof Error) {
          this.$Message.error(error.toString());
        }
      }
    }
  }
  public compareDate(date) {
    if (date < this.getTime(0)) {
      return 0;
    }
    if (date == this.getTime(0)) {
      return 1;
    }
    if (date > this.getTime(0)) {
      return 2;
    }
  }
  public getTime(num) {
    const today = new Date();
    const nowTime = today.getTime();
    const ms: any = 24 * 3600 * 1000 * num;
    today.setTime(parseInt(nowTime + ms, 10));
    const oYear = today.getFullYear();
    let oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = "0" + oMoth;
    let oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = "0" + oDay;
    return oYear + "-" + oMoth + "-" + oDay;
  }
}
